import controller from './related-products.controller';
import templateT1 from './templates/related-products-t1.view.html';
import templateAD from './templates/related-products-adaptative.view.html';

let RelatedProductsComponent = {
    template: changeTemplate,
    controller,
    bindings: {
        shCtrl: '<',
        productRelatedId: '<',
        categoryId: '<'
    }
};

changeTemplate.$inject = ['SessionService'];

function changeTemplate(SessionService) {
    let response = SessionService.get('components');
    if (__env.adaptative) {
        return templateAD;
    } else {
        return templateT1;
    }
}

export default RelatedProductsComponent;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/related-products/related-products.component.js
 **/